/**
 * 隐藏模块
 *
 * @author VenDream
 * @since 2019-11-22
 */

const rpConf = window.RPCONFIG;
const hiddenModules = (rpConf && rpConf.hidden_modules) || [];

/**
 * 模块是否被隐藏
 *
 * @export
 * @param {ModuelsCanBeHidden} module 模块id
 */
export function isModuleHidden(module) {
  return hiddenModules.includes(module);
}
